// Importaciones de paquetes
import React, { useMemo, Suspense, lazy, useState, useEffect, useCallback } from 'react';

import type { MRT_ColumnDef } from "material-react-table";
// Importaciones de componentes
import { Box, Typography, Button, IconButton, Chip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import type { SUPPORTS } from "./interface/interface";
import MATERIAL_TABLE_CONTAINER from "../main_components/material_table/table_container";
import CloseIcon from '@mui/icons-material/Close';

//IMG / ICONS

import CREATE from "../imgComponents/create.png";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { StyledDialog, StyledDialogTitle } from "../main_components/material_table/styles/general_form_styles";


const LazyCommentsSupport = lazy(() => import('./components/tools/custom/comments'));
const LazyTicketForm = lazy(() => import('./components/tools/custom/custom_table'));


export interface FormData {
  id: number | string;
  username: string;
  fullusername: string;
  phone: string;
  email: string;
  job: string;
}
interface TicketListProps {
  tickets: SUPPORTS[];
  onViewAll?: () => void; // nueva prop opcional
  fetchSupports: () => Promise<SUPPORTS[]>;
  flagModal: boolean;
  onUpdateTicket: (updated: SUPPORTS) => void;
  isLoading: boolean; // Added this property
}



const statusColors: Record<string, { bg: string; color: string; label: string }> = {
  'OPEN': { bg: '#E0E7FF', color: '#3730A3', label: 'ABIERTO' },
  'CLOSE': { bg: '#E5E7EB', color: '#6B7280', label: 'FINALIZADO' },
  'PROCESS': { bg: '#e8e4f2', color: '#1E40AF', label: 'EN PROCESO' },
  'REVIEW': { bg: '#FDE68A', color: '#92400E', label: 'EN REVISIÓN' },
  'VALIDATION': { bg: '#FEF9C3', color: '#92400E', label: 'EN VALIDACIÓN' },
};



const TICKET_MANAGER: React.FC<TicketListProps> = ({ tickets, onViewAll, onUpdateTicket, isLoading }) => {
  const [data, setData] = useState<any>([]);
  const [openForm, setOpenForm] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState<null | SUPPORTS>(null);

  const hasValidDomain = (email: string | null): boolean => {
    return email?.endsWith('@herramientasinformaticas.com') || false;
  };
  const email = sessionStorage.getItem("email_user_c");

  const update_identifiers = [
    { username: "string" },
    { fullusername: "string" },
    { phone: "string" },
    { email: "string" },
    { paymethod: "string" },
    { job: "string" },
  ];

  const StatusCell = ({ value }: { value: string }) => {
    const statusInfo = statusColors[value] || {
      bg: '#F3F4F6',
      color: '#6B7280',
      label: value || 'DESCONOCIDO'
    };
    return (
      <span
        style={{
          backgroundColor: statusInfo.bg,
          color: statusInfo.color,
          padding: "4px 12px",
          fontSize: "0.75rem",
          fontWeight: 600,
          borderRadius: "12px",
          display: "inline-block",
          minWidth: "100px",
          textAlign: "center",
        }}
      >
        {statusInfo.label}
      </span>
    );
  };

  const SeverityCell = ({ value }: { value: string }) => {
    const styles = {
      Alta: { background: "#fecaca", color: "#b91c1c" },
      Media: { background: "#fde68a", color: "#92400e" },
      Baja: { background: "#e5e7eb", color: "#374151" },
    }[value] || { background: "#f3f4f6", color: "#1f2937" };

    return (
      <span
        style={{
          backgroundColor: styles.background,
          color: styles.color,
          padding: "4px 12px",
          fontSize: "0.75rem",
          fontWeight: "600",
          borderRadius: "12px",
          display: "inline-block",
        }}
      >
        {value}
      </span>
    );
  };

  const ActionIcon = React.memo(({ onClick }: { onClick: () => void }) => (
    <span onClick={onClick}>
      <ChatBubbleOutlineIcon className="icons_general_save" />
    </span>
  ));


  const columnHeaderIcon: React.ReactNode = useMemo(() => (
    <img
      title="Nuevo ticket"
      style={{ cursor: "pointer" }}
      src={CREATE}
      alt="Nuevo"
      onClick={() => {
        requestAnimationFrame(() => {
          setSelectedTicket(null);
          setOpenForm(true);
        });
      }}
    />
  ), []);

  const CalificationCell = React.memo(({ value }: { value: number | null }) => {
    const maxStars = 5;
    console.log(value)

    if (value === null || value === undefined) {

      console.log(value)
      return <span style={{ fontSize: "0.85rem", color: "#9ca3af" }}>Sin calificar</span>;
    }

    return (
      <span style={{ fontSize: "1rem", color: "#facc15" }}>
        {"★".repeat(value)}{"☆".repeat(maxStars - value)}
      </span>
    );
  });


  const ComentarioCell = React.memo(({ value }: { value: string | null }) => {
    return (
      <span
        style={{
          color: value ? "#1f2937" : "#9ca3af",
          fontStyle: value ? "normal" : "italic",
        }}
      >
        {value && value.trim() !== "" ? value : "Sin comentario"}
      </span>
    );
  });

  const UsuarioCell = React.memo(({ email }: { email: string }) => (
    <span style={{ color: "#191919", textDecoration: "none" }}>
      {email}
    </span>
  ));


  const FechaCell = React.memo(({ value }: { value: string | null }) => {
    if (typeof value !== "string") return <>Fecha no disponible</>;

    const [datePart = "", timePart = ""] = value.split(".")[0]?.split(" ") ?? [];

    return (
      <div style={{ textAlign: "center" }}>
        <span>{datePart}</span>
        <br />
        <span style={{ fontSize: "0.8rem", color: "#6b7280" }}>{timePart}</span>
      </div>
    );
  });

  const handleOpenForm = useCallback((ticket?: SUPPORTS) => {
    setSelectedTicket(ticket ?? null);
    setOpenForm(true);
  }, []);


  useEffect(() => {

    if (isLoading) {
      setData([]);

      setTimeout(() => {
        setData(tickets);
      }, 100);
    }

  }, [isLoading, tickets]);







  const columns: MRT_ColumnDef<SUPPORTS>[] = useMemo(() => {
    const baseColumns: MRT_ColumnDef<SUPPORTS>[] = [
      {
        id: "AC.",
        header: "AC.",
        Header: columnHeaderIcon,
        size: 60,
        Cell: ({ row }) => (
          <ActionIcon onClick={() => handleOpenForm(row.original)} />
        ),

        enableColumnFilter: false,
        enableGlobalFilter: false,
        enableColumnActions: false,
        muiTableBodyCellProps: { align: "center" },
        enableColumnOrdering: false,
        enableColumnDragging: false,
      },

      {
        header: "Fecha",
        id: "date",
        accessorKey: "date",
        size: 120,
        muiTableBodyCellProps: { align: 'center', sx: { fontSize: "0.9rem", fontWeight: "bold", color: "#4b5563" } },
        Cell: ({ cell }) => {
          const value = cell.getValue() as string | null;
          if (!value) return '';
          return new Date(value).toLocaleDateString('es-MX', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
          });
        }

      },

      {
        header: "Folio",
        accessorKey: "folio",
        id: "folio",
        muiTableBodyCellProps: { align: 'center' },
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue() as string;
          return (
            <span
              style={{
                color: "#4338ca",
                fontWeight: "bold",
                fontSize: "0.85rem",
                cursor: "pointer",
              }}
            >
              {value}
            </span>
          );
        }
      },
      {
        header: "Severidad",
        accessorKey: "severity",
        id: "severity",
        muiTableBodyCellProps: { align: 'center' },
        size: 140,
        Cell: ({ cell }) => <SeverityCell value={cell.getValue() as string} />
      },

      {
        header: "Tipo",
        accessorKey: "type",
        id: "type",
        size: 150,
        muiTableBodyCellProps: { align: 'center' },
      },

      {
        header: "Estado",
        accessorKey: "status",
        id: "status",
        size: 120,
        filterVariant: 'select',
        filterSelectOptions: [
          { label: "ABIERTO", value: "OPEN" },
          { label: "FINALIZADO", value: "CLOSE" },
          { label: "EN PROCESO", value: "PROCESS" },
          { label: "EN REVISIÓN", value: "REVIEW" },
          { label: "EN VALIDACIÓN", value: "VALIDATION" },
        ],
        filterFn: (row, id, filterValue) => {
          const val = row.getValue(id);
          // Si filtro es null: buscamos null o undefined explícitamente
          if (filterValue === null) {
            return val === null || val === undefined;
          }
          // Validar que el valor sea un string
          if (typeof val !== 'string') return false;

          return val === filterValue;
        },
        Cell: ({ cell }) => <StatusCell value={cell.getValue() as string} />,
        // Cell: ({ cell }) => <span style={{ color: "#1f2937", fontWeight: "bold" }}>{cell.getValue() as string}</span>,
        muiTableBodyCellProps: { align: 'center' },
      },

      {
        header: "Asunto",
        accessorKey: "subject",
        id: "subject",
        muiTableBodyCellProps: { align: 'justify' },
      },

      {
        header: "Módulo",
        accessorKey: "module",
        id: "module",
        muiTableBodyCellProps: { align: 'justify' },
        size: 160,
        Cell: ({ cell }) => {
          const value = cell.getValue() as string; // 👈 Convertimos a string
          return <span style={{ fontWeight: "bold", color: "#374151" }}>{value?.toUpperCase()}</span>;
        }
      },
      {
        header: "Sub-Módulo",
        accessorKey: "submodule",
        id: "submodule",
        size: 160,
        muiTableBodyCellProps: { align: 'justify' },
        Cell: ({ cell }) => {
          const value = cell.getValue() as string; // 👈 Convertimos a string
          return <span style={{ fontWeight: "bold", color: "#374151" }}>{value?.toUpperCase()}</span>;
        }
      },
      {
        header: "Compañía",
        id: "company_code",
        accessorKey: "company_code",
        size: 120,
        muiTableBodyCellProps: { align: 'center' },
      },
      {
        header: "Usuario",
        accessorKey: "user_name",
        id: "user_name",
        muiTableBodyCellProps: { align: 'justify', sx: { fontSize: "0.9rem", } },
        size: 250,
      },
    ];

    const extraColumns: MRT_ColumnDef<SUPPORTS>[] = hasValidDomain(email)
      ? [
        {

          header: "Calificación",
          accessorKey: "user_rate",
          id: "user_rate",
          size: 180,
          muiTableBodyCellProps: { align: 'center' },
          filterVariant: 'select',
          filterSelectOptions: [
            { label: "Sin estrellas", value: 0 },
            { label: "★", value: 1 },
            { label: "★★", value: 2 },
            { label: "★★★", value: 3 },
            { label: "★★★★", value: 4 },
            { label: "★★★★★", value: 5 },
          ],
          filterFn: (row, id, filterValue) => {
            const val = row.getValue(id);
            if (filterValue === null) {
              return val === null || val === undefined;
            }
            if (typeof val !== 'number') return false;
            return val === filterValue;
          },


          Cell: ({ cell }) => <CalificationCell value={cell.getValue() as number | null} />
        }
        ,
        {
          header: "Comentario",
          accessorKey: "user_rate_comment",
          id: "user_rate_comment",
          size: 250,
          muiTableBodyCellProps: { align: 'justify' },
          Cell: ({ cell }) => <ComentarioCell value={cell.getValue() as string | null} />
        }
      ]
      : [];

    return [...baseColumns, ...extraColumns];
  }, [email]);


  return (
    <div className="muiColorTable">

      <StyledDialog open={openForm} maxWidth="lg" fullWidth>
        <StyledDialogTitle>
          {selectedTicket ? (
            <Typography variant="subtitle1" fontWeight={700} mb={0.5} color={'white'} >
              <Chip label={selectedTicket?.folio} size="small" sx={{ mr: 1, backgroundColor: '#E0E7FF', color: '#3730A3' }} />
              <span style={{ color: 'white' }}>{selectedTicket?.subject}</span>
            </Typography>
          ) : 'ALTA DE TICKET'}
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenForm(false);
              setSelectedTicket(null);
            }}
            sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }}
          >
            <CloseIcon />
          </IconButton>
        </StyledDialogTitle>

        {selectedTicket ? (
          <Suspense fallback={<Typography sx={{ p: 2 }}>Cargando comentarios...</Typography>}>
            <LazyCommentsSupport tickets={selectedTicket} onTicketUpdate={onUpdateTicket} />
          </Suspense>
        ) : (
          <Suspense fallback={<Typography sx={{ p: 2 }}>Cargando formulario...</Typography>}>
            <LazyTicketForm
              handleClose={() => {
                setOpenForm(false);
                setSelectedTicket(null);
              }}
              onTicketUpdate={onUpdateTicket}
            />
          </Suspense>
        )}
      </StyledDialog>
      <br></br>
      <Box sx={{ width: '100%', overflowX: 'auto', }}>
        <MATERIAL_TABLE_CONTAINER
          columns={columns as MRT_ColumnDef<any>[]}
          data={data}
          modalT={false}
          isLoading={false}
          maxHeightTable="65vh"
          // enableRowPinning={false}
          getRowStyle={(row, index) => {
            return row.recurrent_incidence
              ? { backgroundColor: '#FFF7ED' } // 🔶 color prioritario si es recurrente
              : { backgroundColor: index % 2 === 0 ? '#ffffff' : '#f1f3f5' }; // 🔁 patrón blanco/gris
          }}
          search_filters={
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Button
                variant="contained"
                size="small"
                startIcon={<ArrowBackIcon />}
                sx={{
                  backgroundColor: '#0472e9',
                  textTransform: 'none',
                  borderRadius: 2,
                  zIndex: 1000,
                }}
                onClick={() => {
                  requestAnimationFrame(() => {
                    onViewAll?.();
                  });
                }}
              >
                Regresar
              </Button>

            </Box>
          }
          file_name_export="Soportes"
          update_identifiers={update_identifiers}
        />
      </Box>

    </div>
  );
};

export default TICKET_MANAGER;





